<div class="modal-content" (keydown.enter)="onKeydown($event)">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Select Child AWBs</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="col-md-12 grid-container">
                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                        class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                        [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                        [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                        [gridOptions]="gridOptions">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button #saveBtn type="button" class="btn btn-outline-dark" (keydown.enter)="onSaveClick()" (click)="onSaveClick()">Save</button>
    </div>
</div>